import actions from "./en-actions";
import general from "./en-general";
import fields from "./en-fields";
import restaurant from "./models/restaurant";
import tag from "./models/tag";
import review from "./models/review";
import user from "./models/user";

export default {
  actions,
  general,
  fields,
  model: {
    restaurant,
    tag,
    review,
    user
  },
};
